import ArrowRightCircleOutlineIcon from "mdi-react/ArrowRightCircleOutlineIcon";
import React from "react";

const Index = ({ data }) => {
  return (
    <div className="outline-arrow-wrapper" >
                <ArrowRightCircleOutlineIcon />
      {data.map((item, index) => {
        return (
         
            <div className="arrow-content" key={index}>
              <span>{item.text}</span>
              <span>{item.subText}</span>
            </div>
          
        );
      })}
    </div>
  );
};
export default Index;
